const recommendationsHome = {
  activeSimilar() {
    const $similarElement = document.querySelector('.js-recommendation-similar');
    const lastVisitedSKU = window.getCookie('lastVisitedSku');
    if ($similarElement && lastVisitedSKU) {
      $similarElement.style.display = 'block';
      blz.eventTracking.pageView({
        name: document.title,
        showcaseProperties: [
          {
            showcaseType: 'GONDOLA',
            showcaseCount: (blz.globals.showcaseProperties || []).length,
            showcaseTitle: 'Talvez você possa se interessar',
            showcaseIsAutoSorting: true,
            showcaseIsDisplayAsCarousel: true
          }
        ]
      });
    }
  }
};

recommendationsHome.activeSimilar();
